import AudiencePage from './AudiencePage';

const CHAPTERS = [
  {
    num: '01',
    icon: 'self_improvement',
    title: 'Body',
    desc: 'Stress hides in the body long before it shows anywhere else — the jaw, the shoulders, the gut. Learn to read those signals early, with practices built for how men actually live and work.'
  },
  {
    num: '02',
    icon: 'visibility',
    title: 'Truth',
    desc: 'Most men were handed two acceptable emotions: fine and angry. This chapter expands the vocabulary — name what\'s really underneath, honestly, without it costing you respect.'
  },
  {
    num: '03',
    icon: 'spa',
    title: 'Soul',
    desc: 'Purpose beyond providing. Simple mind practices that build quiet inner steadiness and connection — the kind of strength that doesn\'t need to prove itself.'
  },
  {
    num: '04',
    icon: 'hearing',
    title: 'Senses',
    desc: 'How you read a challenge, a criticism, a silence decides your reaction. Understand your perception — and choose response over reflex.'
  }
];

const ForMen = () => (
  <AudiencePage
    slug="men"
    eyebrow="For Men"
    title={<>Strength that knows<br />what it feels.</>}
    intro="Men are taught to provide, protect, and endure — rarely to name what they feel. The cost shows up quietly: isolation, anger, silent stress. mindpulsei turns emotional awareness into practical, trainable strength."
    image="https://images.unsplash.com/photo-1763293203875-4883b6716a8c?w=1200&q=80&auto=format&fit=crop"
    imageAlt="Man in calm reflection by the sea at sunset"
    chapters={CHAPTERS}
    quote="Feeling deeply isn't soft. It's the hardest kind of strong."
    quoteSub="Talk to us — practical, private, and shaped around your life."
  />
);

export default ForMen;
